// extracted by mini-css-extract-plugin
export var searchHeader = "_7b-0";
export var searchHeaderDark = "_7b-1";